



























import Vue from "vue";
import iwInputRadioGroup from "@/encoding/components/buildingBlocks/InputRadioGroup.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        iwInputRadioGroup: iwInputRadioGroup,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            pathInStore: "property.certificates.oilTankCertificateStatus",
            inputName: "oil-tank-certificates",
            specificId: uuidv4() as string,
            options:  [
                {"value": "YES_CONFORM", "label": "YES_CONFORM"},
                {"value": "YES_NOT_CONFORM", "label": "YES_NOT_CONFORM"},
                {"value": "NO", "label": "NO"},
                {"value": "NOT_SPECIFIED", "label": "NOT_SPECIFIED"},
            ]
        };
    },
    computed: {
        oilTankCertificatesValue: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "NOT_SPECIFIED";
        },
        isDisplayed: function(): boolean {
            return ["HOUSE","OFFICE","INDUSTRY","COMMERCIAL","APARTMENT","OTHER","GARAGE"].indexOf(this.getPropertyType()) !== - 1;
        },
    },
    mounted: function() {
        if (this.isDisplayed) {
            if(this.$store.getters["FormModule/getValue"](this.pathInStore) == null) {
                this.$store.dispatch("FormModule/addValue", {path: this.pathInStore, value: "NOT_SPECIFIED"});
            }
        } else {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateOilTankCertificates: function(oilTankCertificates: string): void {
            if (oilTankCertificates.length) {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": oilTankCertificates});
            }
        }
    }
});
